import { useCallback, useEffect, useState } from "react";
import CreateButton from "./buttonCreate";

import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getAllButtons,
  getButton,
  deleteButton,
} from "../../../../../action/masters/buttonActionCreator";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IButtonIndex,
  IButtonData,
} from "../../../../../models/master/buttons";
import { setButtons } from "../../../../../store/slices/master/buttonSlice";
import ButtonEdit from "./buttonEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";

const ButtonsIndex = (props: IButtonIndex) => {
  const {
    getButtons,
    buttons,
    getButton,
    button,
    deleteButton,
    userTypes,
    getUserTypes
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getButton(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const getAllButtons = async (userType?: number) => {
    setIsLoading(true);
    try {
      await getButtons(userType);
    } finally {
      setIsLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteButton(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllButtons(selectedUserType ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const onUserTypeChange = useCallback((e: any) => {
    if (e.target.name == "userType")
      setSelectedUserType(e.target.value)
    getAllButtons(e.target.value)
  }, [])

  useEffect(() => {
    getAllButtons();
    getUserTypes();
    return () => {
      dispatch(setButtons([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Buttons</h2>
          <div className="side-filter">
            <div className="justify-content-left">
              <FloatingLabelDropDown
              label=""
              placeholder="-Select UserType-"
              onChange={(e : any) => onUserTypeChange(e)}
              isMandatory={false}
              value={selectedUserType}
              name="userType"
              optionsList={sortAlphabetically(
                userTypes?.filter((type) => type.id !== UserTypes.Freshman)
              )}
            />
          </div>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : buttons && buttons.length > 0 ? (
            buttons.map((button: IButtonData) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !button.isActive ? "none" : "auto",
                    opacity: !button.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(button.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(button.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={button.url} target="_blank">
                    <div className="btm">
                      <h2 className="btn-name para-hide-1">{button.name}</h2>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
        <ReactModal
          isOpen={showCreate}
          onRequestClose={handleCreateClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <CreateButton
            setShowCreate={handleCreateClose}
            getAllButtons={() => getAllButtons(selectedUserType ?? undefined)}
          />
        </ReactModal>

        {isEditLoading ? (
          <LoaderSpinner />
        ) : (
          <ReactModal
            isOpen={showEdit}
            onRequestClose={handleEditClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <ButtonEdit
              setShowEdit={handleEditClose}
              getAllButtons={() => getAllButtons(selectedUserType ?? undefined)}
              button={button}
            />
          </ReactModal>
        )}

        <SweetAlert
          show={showAlert}
          success={false}
          type={alertType}
          title={alertTitle}
          onConfirm={() => onConfirm()}
          showCancel={isDelete}
          onCancel={() => {
            setShowAlert(false);
            setIsDelete(false);
          }}
          cancelBtnText={"No"}
          confirmBtnText={isDelete ? "Yes" : "Ok"}
        />
      </div>
    </>
  );
};
const mapDispatchToProps = {
  getButtons: (userType?:number) => getAllButtons(userType),
  getButton: (id: number) => getButton(id),
  deleteButton: (id: number, callBack: Function) => deleteButton(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    buttons: state.button.buttons,
    button: state.button.button,
    userTypes: state.common.userTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonsIndex);
